import React from "react";
import { Link } from "react-router-dom";

import { Subscription } from "../../api/grpc/subscription/subscription";
import { PageHeader } from "../shared/PageHeader/PageHeader";

import { ProductStorePricingMode } from "./ProductStore.types";
import { canSeePrices } from "./productStorePricing";
import { getProductStoreSubscriptionSummary } from "./productStoreSubscription";

const HeaderDescription = () => (
  <>
    <span>
      Order products and services with direct delivery to most countries.
    </span>
    <span>You can also review or change your subscription at any time.</span>
  </>
);

interface Props {
  pricingMode: ProductStorePricingMode;
  subscription: { loading: boolean; error?: unknown; data?: Subscription };
}

export const ProductStoreHeader = ({ pricingMode, subscription }: Props) => {
  const { loading, error, data } = subscription;

  const summary = data ? getProductStoreSubscriptionSummary(data) : undefined;

  return (
    <PageHeader
      title="Product Store"
      description={<HeaderDescription />}
      className="ProductStoreHeader"
    >
      <aside
        className="ProductStoreHeader__subscription"
        aria-label="Current subscription"
        aria-busy={loading}
      >
        <div className="ProductStoreHeader__subscriptionContent">
          <span className="ProductStoreHeader__label">
            Current subscription
          </span>
          {loading ? (
            <>
              <span className="ProductStoreHeader__skeleton ProductStoreHeader__skeleton--title" />
              <span className="ProductStoreHeader__skeleton ProductStoreHeader__skeleton--meta" />
            </>
          ) : error || !summary ? (
            <>
              <strong>Subscription unavailable</strong>
              <span>Review your details in Billing</span>
            </>
          ) : (
            <>
              <strong>
                {summary.plan} · {summary.period}
              </strong>
              <span>{summary.details.join(" · ")}</span>
            </>
          )}
        </div>
        {canSeePrices(pricingMode) && (
          <Link
            className="ProductStoreHeader__billingLink"
            to="/settings/billing/subscriptions"
          >
            Edit in Billing
          </Link>
        )}
      </aside>
    </PageHeader>
  );
};
